import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { ArchiveLinkRequestActionPayload, ArchiveLinkResponseActionPayload } from '../AdLinks.types';

export const ArchiveAdsLinkAsyncAction = new ReduxAsyncAction<
  'LINK_CREATOR_ARCHIVE_LINK',
  ArchiveLinkRequestActionPayload,
  ArchiveLinkResponseActionPayload
>('LINK_CREATOR_ARCHIVE_LINK');

export const ARCHIVE_LINK_ACTION_CONSTANTS = ArchiveAdsLinkAsyncAction.actionNamespaceConstants;

ArchiveAdsLinkAsyncAction.registerRequest(async (payload) => {
  const { data } = await dash_api.put<ArchiveLinkResponseActionPayload>(
    `/v1/link-creator/ads/${payload.link_id}/${payload.archived}`,
    payload
  );
  return data;
});

ArchiveAdsLinkAsyncAction.showProgressBar();

export const archiveAdsLink = ArchiveAdsLinkAsyncAction.request;

export type ArchiveLinkResponseAction = Action<typeof ARCHIVE_LINK_ACTION_CONSTANTS.response> & {
  data: ArchiveLinkResponseActionPayload;
};
